import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { EnhancedDetailPanel } from 'components/enhanced/data-grid/components';
import { memo, useCallback, useMemo } from 'react';
import { unapprovedMovementService } from '../api/unapproved-movement.service';

const DetailPanelContent = ({ row, noDDT, columns, uuid, setSelectedMovements }: any) => {
  const params = useMemo(() => ({ ...row, noDDT }), [row, noDDT]);

  const handleSelectionModelChange = useCallback(
    (newRowSelectionModel) => {
      setSelectedMovements(uuid, newRowSelectionModel);
    },
    [setSelectedMovements, uuid]
  );

  return (
    <EnhancedDetailPanel>
      <EnhancedDataGrid
        columns={columns}
        service={unapprovedMovementService}
        outerParams={params}
        checkboxSelection={true}
        selectionModelChange={handleSelectionModelChange}
      />
    </EnhancedDetailPanel>
  );
};

export default memo(DetailPanelContent);
